// ------------------------------
// загрузка и конвертация
const fileInput = document.getElementById('fileInput');
const fileAddInput = document.getElementById('fileAddInput');
const modelName = document.getElementById('modelName');
const modelDescription = document.getElementById('modelDescription');
const uploadBtn = document.getElementById('upload-btn');
const addBtn = document.getElementById('add-btn');
const spinner = document.getElementById('spiner');
const resultLink = document.getElementById('finalLink');
const resultOpen = document.getElementById('finalOpen');
const statusEl = document.getElementById('status-info');
const fileInfoEl = document.getElementById('files-info');
const textureInfoEl = document.getElementById('texture-info');
const loadDialog = document.getElementById('load-dialog');
const linkDialog = document.getElementById('link-dialog');
const mtleditBtn = document.getElementById('mtledit-btn');
const mtlDialog = document.getElementById('mtl-dialog');
const maxFile = document.getElementById('analytics') ? 99 : 25;
// Просмотр
let scene, camera, renderer, controls, model, modelGroup;
let isUserInteracting = false;
let autoRotateTimeout = null;
let animationFrameId = null;
let mtlText = '';
let getMtlFromEdit = false;
const s3vContainer = document.getElementById('container');
// Хранилище для файлов
let filesMap = new Map();
let objFile = null;
let mtlFile = null;
let zipFile = null;      // проект Базиса: zip из выгрузчика BFM_Export.js
let mtlTempFile = null;
let textureFiles = [];
let isBazizModel = false;
// событие изменения списка файлов
if (fileInput) { 
    fileInput.addEventListener('change', function() {
      if (this.files.length > 0) {
          handleFiles(this.files);
      }
  });
}
if (fileAddInput) { 
  fileAddInput.addEventListener('change', function() {
    if (this.files.length > 0) {
        handleAddFiles(this.files);
    }
});
}
//обновление интерфейса
//тут мы управляем элементами диалога
function updateUI() {
    // Очищаем сцену и готовим к загрузке новой модели
    cleanupScene(); // Очистка перед загрузкой новой модели
    isUserInteracting = false;

    // ---- Проект Базиса (.zip): конвертация на сервере, клиент не парсит ----
    if (zipFile) {
      modelName.value = zipFile.name.replace(/\.zip$/i, '');
      modelDescription.value = '';
      loadDialog.setAttribute('open', '');

      fileInfoEl.textContent = `Проект Базиса: ${zipFile.name}`;
      textureInfoEl.textContent = 'Внутри архива: model.json, меши и текстуры. Конвертация в GLB — на сервере';

      uploadBtn.disabled = false;
      addBtn.disabled = false;

      // конвертация и предпросмотр — прямо в браузере
      convertZipFiles();
      return;
    }

    if (objFile) {
      // открываем диалог загрузки
      modelName.value = '';
      modelDescription.value = '';
      loadDialog.setAttribute('open', '');

      let statusText = `Основной файл: ${objFile.name}`;
      
      if (mtlFile) {
        statusText += ` | MTL файл: ${mtlFile.name}`;
      } else {
        //showAlert("Вы не выбрали MTL файл.");
        //addAlert("Добавьте через кнопку 'Добавить'.")
      }
      
      if (textureFiles.length > 0) {
        statusText += ` | Текстур: ${textureFiles.length}`;
        textureInfoEl.textContent = `Текстуры: ${textureFiles.map(f => f.name).join(', ')}`;
      } else {
        textureInfoEl.textContent = 'Текстуры не обнаружены';
        mtlTempFile = mtlFile;
       // mtlFile = null;
        showAlert("Вы не выбрали файлы текстур");
        addAlert("Добавьте их перед загрузкой на сервер.");
      }
      
      fileInfoEl.textContent = statusText;
      uploadBtn.disabled = false;
      addBtn.disabled = false;
      
      //запускаем конвертацию
      convertFiles();
    } else {
      //statusEl.textContent = 'Пожалуйста, выберите OBJ файл';
      //fileInfoEl.textContent = 'OBJ файл не обнаружен';
      showAlert('Пожалуйста, выберите OBJ файл');
      addAlert('OBJ файл не обнаружен')
      textureInfoEl.textContent = '';
      uploadBtn.disabled = true;
      addBtn.disabled = true;
    }
}

// Drag and drop functionality
const dropzone = document.querySelector('.dropzone');

if (dropzone) {
  dropzone.addEventListener('dragover', function(e) {
      e.preventDefault();
      this.style.backgroundColor = '#666';
  });

  dropzone.addEventListener('dragleave', function(e) {
      e.preventDefault();
      this.style.backgroundColor = 'transparent';
  });

  dropzone.addEventListener('drop', function(e) {
      e.preventDefault();
      this.style.backgroundColor = 'transparent';
      
      if (e.dataTransfer.files.length) {
          const dt = e.dataTransfer;
          const files = dt.files;
          handleFiles(files);
          const event = new Event('change');
          fileInput.dispatchEvent(event);
      }
  });
}

function handleFiles(files) {
    // Сброс предыдущих файлов
    filesMap.clear();
    objFile = null;
    mtlFile = null;
    zipFile = null;
    textureFiles = [];
    
    // Организация файлов
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const ext = file.name.split('.').pop().toLowerCase();
      filesMap.set(file.name, file);
      
      if (ext === 'obj') {
        // Проверка размера OBJ файла (10 МБ = 10 * 1024 * 1024 байт)
        if (file.size > maxFile * 1024 * 1024) {
          showAlert('Размер OBJ файла не должен превышать ' + maxFile + ' МБ!', 'danger');
          return;
        }
        objFile = file;
      } else if (ext === 'mtl') {
        mtlFile = file;
        getMtlFromEdit = false;
      } else if (ext === 'zip') {
        // Проект Базиса: внутри model.json, меши и текстуры.
        // Конвертация в GLB идёт на сервере, клиент ничего не парсит.
        if (file.size > 300 * 1024 * 1024) {
          showAlert('Размер проекта не должен превышать 300 МБ!', 'danger');
          return;
        }
        zipFile = file;
      } else if (['jpg', 'jpeg', 'png', 'bmp', 'tga'].includes(ext)) {
        textureFiles.push(file);
      }
    }

    // zip и obj одновременно не имеют смысла: zip самодостаточен
    if (zipFile) {
      objFile = null;
      mtlFile = null;
      textureFiles = [];
    }
    
    // Обновление интерфейса
    updateUI();
}

function handleAddFiles(files) {
  // Сброс предыдущих файлов
  filesMap.clear();
  let objAddFile = null;
  let mtlAddFile = null;
  let zipAddFile = null;
  let textureAddFiles = [];
  
  // Организация файлов
  for (let i = 0; i < files.length; i++) {
    const file = files[i];
    const ext = file.name.split('.').pop().toLowerCase();
    filesMap.set(file.name, file);
    
    if (ext === 'obj') {
      // Проверка размера OBJ файла (10 МБ = 10 * 1024 * 1024 байт)
      if (file.size > maxFile * 1024 * 1024) {
        showAlert('Размер OBJ файла не должен превышать ' + maxFile + ' МБ!', 'danger');
        return;
      }
      objAddFile = file;
    } else if (ext === 'mtl') {
      mtlAddFile = file;
    } else if (ext === 'zip') {
      if (file.size > 300 * 1024 * 1024) {
        showAlert('Размер проекта не должен превышать 300 МБ!', 'danger');
        return;
      }
      zipAddFile = file;
    } else if (['jpg', 'jpeg', 'png', 'bmp', 'tga'].includes(ext)) {
      textureAddFiles.push(file);
    }
  }
  
  if (zipAddFile) {
    // zip заменяет весь набор: он самодостаточен
    zipFile = zipAddFile;
    objFile = null;
    mtlFile = null;
    textureFiles = [];
  } else if (objAddFile) { 
    objFile = objAddFile;
  } else if( mtlAddFile) {
    mtlFile = mtlAddFile;
    getMtlFromEdit = false;
  } else if (textureAddFiles.length > 0) {
    textureFiles.push(...textureAddFiles);
  }
  // Обновление интерфейса
  updateUI();
}

let glbBlob;

    // Конвертация проекта Базиса (.zip) целиком в браузере: zip → three-сцена → GLB
    const convertZipFiles = async () => {
      if (!zipFile) return;
      if (!window.BASIS2GLB) {
        showStatus('Конвертер Базиса не загрузился, обновите страницу');
        return;
      }
      try {
        uploadBtn.disabled = true;
        addBtn.disabled = true;
        modelName.disabled = true;
        modelDescription.disabled = true;
        showLoadingCursor();
        spinner.classList.remove('hidden-field');
        statusEl.classList.remove('hidden-field');
        statusEl.textContent = 'Разбор проекта Базиса...';

        showS3V();
        const progressInterval = fackeProgessStatus('Конвертация проекта ...');

        // 1. zip → сцена three
        const buffer = await zipFile.arrayBuffer();
        const built = await window.BASIS2GLB.basisZipToScene(buffer);
        console.log('[базис] сцена собрана:', built.stats);

        // 2. предпросмотр в том же канвасе, что и для obj
        if (modelGroup && modelGroup.parent) {
          modelGroup.parent.remove(modelGroup);
        }
        modelGroup = new THREE.Group();
        modelGroup.add(built.root);
        scene.add(modelGroup);
        model = built.root;
        window.__BASIS_ANIMATIONS = built.animations || [];
        try { makePreviewShadow(built.root); } catch (eSh) { console.warn('[preview] тень:', eSh.message); }
        try { fitPreviewShadow(built.root); } catch (eFs) { console.warn('[preview] тени:', eFs.message); }
        fitCameraToObject(camera, built.root, controls);

        statusEl.textContent = 'Сборка GLB...';

        // 3. сцена → GLB (штатный экспортёр three 0.180)
        const glb = ensureGlbBuffer(await window.BASIS2GLB.sceneToGlb(built.root, built.animations));
        glbBlob = new Blob([glb], { type: 'model/gltf-binary' });

        /* GLB уже собран — можно упростить материалы для превью */
        try { flattenPreviewMaterials(built.root); } catch (eFlat) { console.warn('[preview] упрощение материалов:', eFlat.message); }
        try { hidePreviewExtras(built.root); } catch (eHw) { console.warn('[preview] скрытие присадки:', eHw.message); }

        modelName.value = zipFile.name.replace(/\.zip$/i, '');
        clearInterval(progressInterval);
        statusEl.textContent = 'Готово: ' + built.stats.panels + ' панелей, ' +
          built.stats.hardware + ' ед. фурнитуры, ' + built.stats.lights + ' источников света';

        spinner.classList.add('hidden-field');
        uploadBtn.disabled = false;
        addBtn.disabled = false;
        modelName.disabled = false;
        modelDescription.disabled = false;
        hideLoadingCursor();
      } catch (error) {
        hideLoadingCursor();
        console.error('Ошибка конвертации проекта Базиса:', error);
        spinner.classList.add('hidden-field');
        statusEl.textContent = 'Ошибка: ' + error.message;
        showStatus('Ошибка: ' + error.message);
        uploadBtn.disabled = true;
      }
    };

    // Основная функция конвертации
    const convertFiles = async () => {
      if (!objFile || zipFile) return;   // zip конвертируется на сервере
      
      try {
        addBtn.disabled = true;
        uploadBtn.disabled = true;
        modelName.disabled = true;
        modelDescription.disabled = true;
        showLoadingCursor();
        //const alert = showBusyAlert('Начата конвертация...');
        spinner.classList.remove('hidden-field');
        statusEl.textContent = 'Начата конвертация...';
        statusEl.classList.remove('hidden-field');

        //показываем канву
        showS3V();

        // Показываем прогресс
        //const progressInterval = fackeProgess(alert,'Конвертация ...');
        const progressInterval = fackeProgessStatus('Конвертация ...');
        
        // Загрузка и конвертация
        const glbData = ensureGlbBuffer(await convertOBJtoGLB(objFile, mtlFile, textureFiles));

        clearInterval(progressInterval);
        statusEl.textContent = 'Конвертация ... 100%'

        // Создаем файл для загрузки
        glbBlob = new Blob([glbData], { type: 'model/gltf-binary' });
 
        modelName.value = objFile.name;
        
        
        spinner.classList.add('hidden-field');
        showStatus('Конвертация завершена!');
        //closeAlert(alert);

        uploadBtn.disabled = false;
        addBtn.disabled = false;
        modelName.disabled = false;
        modelDescription.disabled = false;
        hideLoadingCursor();
      } catch (error) {
        hideLoadingCursor();
        console.error('Ошибка конвертации:', error);
        spinner.classList.add('hidden-field');
        statusEl.textContent = `Ошибка: ${error.message}`;
      }
    };

    async function convertOBJtoGLB(objFile, mtlFile, textureFiles) {
      return new Promise(async (resolve, reject) => {
        try {
          // Создаем карту для быстрого доступа к текстурам
          const textureMap = new Map();
          const textureLoader = new THREE.TextureLoader();
          // Массив промисов загрузки текстур
          const texturePromises = [];
          // Загружаем все текстуры (кладём именно файлы, а не THREE.Texture)
          for (const file of textureFiles) {
            textureMap.set(file.name.toLowerCase(), file);
          }
          console.log('Доступные текстуры:', Array.from(textureMap.keys()));
    
          let materials = null;
          
          // Если есть MTL файл, загружаем материалы
          if (mtlFile || getMtlFromEdit) {
            if (!getMtlFromEdit) {
              mtlText = await readFileAsText(mtlFile);              
            
              mtlText = mtlText.replace(/\\/g, '/'); // Заменяем обратные слеши
              
              // Удаляем все пути, оставляем только имена файлов для всех типов текстур
              mtlText = mtlText.replace(/map_Kd\s+[^\/\\]*[\/\\]/g, 'map_Kd ');
              mtlText = mtlText.replace(/map_Ks\s+[^\/\\]*[\/\\]/g, 'map_Ks ');
              mtlText = mtlText.replace(/map_Bump\s+[^\/\\]*[\/\\]/g, 'map_Bump ');
              mtlText = mtlText.replace(/map_d\s+[^\/\\]*[\/\\]/g, 'map_d ');
              mtlText = mtlText.replace(/map_Ka\s+[^\/\\]*[\/\\]/g, 'map_Ka ');
              mtlText = mtlText.replace(/map_Ns\s+[^\/\\]*[\/\\]/g, 'map_Ns ');
              
              // Очищаем пустые строки map_Kd, map_Ks и т.д. если после них нет файлов
              mtlText = mtlText.replace(/map_Kd\s*\n/g, '\n');
              mtlText = mtlText.replace(/map_Ks\s*\n/g, '\n');
              mtlText = mtlText.replace(/map_Bump\s*\n/g, '\n');
              mtlText = mtlText.replace(/map_d\s*\n/g, '\n');
              mtlText = mtlText.replace(/map_Ka\s*\n/g, '\n');
              mtlText = mtlText.replace(/map_Ns\s*\n/g, '\n');
              
              // ДОБАВЛЯЕМ ПРАВИЛА ДЛЯ ПРОЗРАЧНОСТИ ПРЯМО В MTL ТЕКСТ
              const lines = mtlText.split('\n');
              let modifiedMtlText = '';
            
              for (const line of lines) {
                let modifiedLine = line;
                const isNewMtl = line.trim().startsWith('newmtl ');
                
                // Если находим материал с именем, содержащим "Steklo" и у него нет прозрачности
                if (isNewMtl && line.includes('Steklo')) {
                  modifiedMtlText += line + '\n';
                  // Проверяем, есть ли уже прозрачность в следующей строке
                  let hasTransparency = false;
                  for (let i = lines.indexOf(line) + 1; i < lines.length; i++) {
                    const nextLine = lines[i].trim();
                    if (nextLine.startsWith('newmtl ')) break;
                    if (nextLine.startsWith('d ') || nextLine.startsWith('Tr ')) {
                      hasTransparency = true;
                      break;
                    }
                  }
                  if (!hasTransparency) {
                    modifiedMtlText += 'Tr 0.7\n';
                  }
                }
                // Аналогично для PPR
                else if (isNewMtl && line.includes('PPR')) {
                  modifiedMtlText += line + '\n';
                  let hasTransparency = false;
                  for (let i = lines.indexOf(line) + 1; i < lines.length; i++) {
                    const nextLine = lines[i].trim();
                    if (nextLine.startsWith('newmtl ')) break;
                    if (nextLine.startsWith('d ') || nextLine.startsWith('Tr ')) {
                      hasTransparency = true;
                      break;
                    }
                  }
                  if (!hasTransparency) {
                    modifiedMtlText += 'Tr 0.5\n';
                  }
                }
                // Новое правило для фасадов Fasad1/2/3
                else if (isNewMtl && (line.includes('Fasad1') || line.includes('Fasad2') || line.includes('Fasad3'))) {
                  modifiedMtlText += line + '\n';
                  let hasTransparency = false;
                  for (let i = lines.indexOf(line) + 1; i < lines.length; i++) {
                    const nextLine = lines[i].trim();
                    if (nextLine.startsWith('newmtl ')) break;
                    if (nextLine.startsWith('d ') || nextLine.startsWith('Tr ')) {
                      hasTransparency = true;
                      break;
                    }
                  }
                  if (!hasTransparency) {
                    modifiedMtlText += 'Tr 0.4\n';
                  }
                } else {
                  // Проверяем строки с текстурами (map_Kd) на наличие файлов
                  if (line.trim().startsWith('map_Kd ')) {
                    const texturePath = line.trim().substring(7).trim();
                    const fileName = texturePath.split(/[\\/]/).pop().toLowerCase();
                    
                    // Если файл текстуры не найден в textureMap, добавляем цвет Kd
                    if (!textureMap.has(fileName)) {
                      modifiedMtlText += 'Kd 200 200 200\n'; // Серый цвет вместо отсутствующей текстуры
                    } else {
                      modifiedMtlText += line + '\n';
                    }
                  } else {
                    modifiedMtlText += line + '\n';
                  }
                }
              }
            
              mtlText = modifiedMtlText;
            }
            
            console.log('Обработанный MTL текст:', mtlText);
    
            const mtlLoader = new THREE.MTLLoader();
            
            // Устанавливаем функцию загрузки текстур для MTL
            mtlLoader.setMaterialOptions({
              ignoreZeroRGBs: false, // Важно: обрабатывать цвета даже если они (0,0,0)
              invertTrProperty: true
            });
        
            mtlLoader.manager = new THREE.LoadingManager();
    
            console.log('Парсим MTL:', mtlText);
            materials = mtlLoader.parse(mtlText);    
            console.log('Загруженные материалы:', materials);
            
            // Более точная проверка формата
            function parseColorValuesAdvanced(rStr, gStr, bStr) {
              const r = parseFloat(rStr);
              const g = parseFloat(gStr);
              const b = parseFloat(bStr);
              
              console.log(rStr,gStr,bStr);
              // Определяем формат по характерным признакам
              const isZeroToOneFormat = 
                (r >= 0 && r <= 1.0) && 
                (g >= 0 && g <= 1.0) && 
                (b >= 0 && b <= 1.0) &&
                (!rStr.includes('.') || rStr.split('.')[1]?.length <= 2) &&
                (!gStr.includes('.') || gStr.split('.')[1]?.length <= 2) &&
                (!bStr.includes('.') || bStr.split('.')[1]?.length <= 2);
              
              if (isZeroToOneFormat) {
                console.log(`Формат 0-1: ${r}, ${g}, ${b}`);
                return { r, g, b };
              } else {
                console.log(`Формат 0-255: ${r}, ${g}, ${b} -> ${(r/255).toFixed(3)}, ${(g/255).toFixed(3)}, ${(b/255).toFixed(3)}`);
                return {
                  r: r / 255,
                  g: g / 255, 
                  b: b / 255
                };
              }
            }
        // Функция для дополнительной обработки цветов материалов
        function enhanceMaterialColors(material, materialName) {
          // Парсим MTL текст чтобы извлечь точные значения цветов
          const materialBlock = extractMaterialBlock(mtlText, materialName);
          if (materialBlock) {
          console.log(`Обрабатываем блок материала ${materialName}:`, materialBlock);
          
          // Обрабатываем диффузный цвет (Kd) - значения 0-255
          const kdMatch = materialBlock.match(/^Kd\s+([\d.-]+)\s+([\d.-]+)\s+([\d.-]+)/m);
          if (kdMatch) {
            const lcolor = parseColorValuesAdvanced(kdMatch[1], kdMatch[2], kdMatch[3]);
            material.color = new THREE.Color(lcolor.r, lcolor.g, lcolor.b);
            console.log(`Установлен диффузный цвет для ${materialName}:`, material.color, `(из значений: ${kdMatch[1]}, ${kdMatch[2]}, ${kdMatch[3]})`);
          }
          
          // Обрабатываем зеркальный цвет (Ks) - значения 0-255
          const ksMatch = materialBlock.match(/^Ks\s+([\d.-]+)\s+([\d.-]+)\s+([\d.-]+)/m);
          if (ksMatch) {
            const lcolor = parseColorValuesAdvanced(ksMatch[1], ksMatch[2], ksMatch[3]);
            material.specular = new THREE.Color(lcolor.r, lcolor.g, lcolor.b);
            console.log(`Установлен зеркальный цвет для ${materialName}:`, material.specular, `(из значений: ${ksMatch[1]}, ${ksMatch[2]}, ${ksMatch[3]})`);
          }
          
          // Обрабатываем ambient цвет (Ka) - значения 0-255
          const kaMatch = materialBlock.match(/^Ka\s+([\d.-]+)\s+([\d.-]+)\s+([\d.-]+)/m);
          if (kaMatch) {
            const lcolor = parseColorValuesAdvanced(kaMatch[1], kaMatch[2], kaMatch[3]);
            material.emissive = new THREE.Color(lcolor.r * 0.1, lcolor.g * 0.1, lcolor.b * 0.1);
            console.log(`Установлен ambient цвет для ${materialName}:`, material.emissive, `(из значений: ${kaMatch[1]}, ${kaMatch[2]}, ${kaMatch[3]})`);
          }
          
          // Обрабатываем прозрачность (d или Tr) - значения 0-1
          // Ищем отдельные строки с d или Tr
          const lines = materialBlock.split('\n');
          for (const line of lines) {
            const trimmedLine = line.trim();
            
            // Проверяем строку, начинающуюся с d (прозрачность)
            if (trimmedLine.startsWith('d ')) {
            const dValue = trimmedLine.substring(2).trim();
            const dMatch = dValue.match(/^([\d.]+)/);
            if (dMatch) {
              material.opacity = parseFloat(dMatch[1]);
              material.transparent = material.opacity < 1.0;
              console.log(`Установлена прозрачность (d) для ${materialName}:`, material.opacity);
              break;
            }
            }
            
            // Проверяем строку, начинающуюся с Tr (прозрачность, обратная d)
            if (trimmedLine.startsWith('Tr ')) {
            const trValue = trimmedLine.substring(3).trim();
            const trMatch = trValue.match(/^([\d.]+)/);
            if (trMatch) {
              material.opacity = 1.0 - parseFloat(trMatch[1]);
              material.transparent = material.opacity < 1.0;
              console.log(`Установлена прозрачность (Tr) для ${materialName}:`, material.opacity, `(из Tr: ${trMatch[1]})`);
              break;
            }
            }
          }
          
          // Обрабатываем зеркальность (Ns) - значения 0-1000
          const nsMatch = materialBlock.match(/^Ns\s+([\d.-]+)/m);
          if (nsMatch) {
            material.shininess = parseFloat(nsMatch[1]);
            console.log(`Установлена зеркальность для ${materialName}:`, material.shininess);
          }
          
          // Обрабатываем illumination model (illum)
          const illumMatch = materialBlock.match(/^illum\s+(\d+)/m);
          if (illumMatch) {
            material.illum = parseInt(illumMatch[1]);
            console.log(`Установлена модель освещения для ${materialName}:`, material.illum);
          }
          
          // Извлекаем кастомные параметры
          const fasadeParam = materialBlock.match(/^Fasad\s+(\d+)/m);
          if (fasadeParam) {
            material.opacity = 0.6;
            material.transparent = true;
            material.userData = {
              fasade: parseInt(fasadeParam[1]) || 0,
            };
            console.log(`Установлен кастомный параметр fasade для ${materialName}:`, material.userData.fasade);
          }

          material.needsUpdate = true;
          }
        }
            
            // Функция для извлечения блока материала из MTL текста
            function extractMaterialBlock(mtlText, materialName) {
              const lines = mtlText.split('\n');
              let inMaterialBlock = false;
              let materialBlock = '';
              
              for (const line of lines) {
                const trimmedLine = line.trim();
                
                if (trimmedLine.startsWith('newmtl ')) {
                  if (inMaterialBlock) {
                    break; // Достигли следующего материала
                  }
                  const currentMaterialName = trimmedLine.substring(7).trim();
                  if (currentMaterialName === materialName) {
                    inMaterialBlock = true;
                    materialBlock += line + '\n';
                  }
                } else if (inMaterialBlock) {
                  if (trimmedLine === '' || trimmedLine.startsWith('newmtl ')) {
                    break;
                  }
                  materialBlock += line + '\n';
                }
              }
              
              return inMaterialBlock ? materialBlock : null;
            }
            
            // Переопределяем метод loadTexture у MaterialCreator
            const originalLoadTexture = materials.loadTexture.bind(materials);
            materials.loadTexture = function(url, mapping, onLoad, onProgress, onError) {
              console.log('Загрузка текстуры:', url);
              const fileName = url.split('/').pop().split('\\').pop().toLowerCase();
              const textureFile = textureMap.get(fileName);
              
              if (textureFile) {
                const textureUrl = URL.createObjectURL(textureFile);
                const loader = new THREE.TextureLoader();
                //loader.flipY = false;
                
                // Создаём промис загрузки
                const promise = new Promise((resolve, reject) => {
                  loader.load(
                    textureUrl,
                    (tex) => {
                      URL.revokeObjectURL(textureUrl);
                      //tex.flipY = false;
                      if (mapping !== undefined) tex.mapping = mapping;
                      tex.name = fileName;
                      if (onLoad) onLoad(tex);
                      resolve(tex);
                    },
                    onProgress,
                    (err) => {
                      if (onError) onError(err);
                      reject(err);
                    }
                  );
                });
                texturePromises.push(promise);
                return loader.load(textureUrl);
              } else {
                console.log('Текстура не найдена:', fileName);
                if (onLoad) onLoad(null);
                return null;
              }
            };
            
            console.log('предзагрузка текстур');
            materials.preload();
            
            // Дополнительная обработка цветов после загрузки материалов
            if (materials.materials) {
              for (const materialName in materials.materials) {
                if (materials.materials.hasOwnProperty(materialName)) {
                  const material = materials.materials[materialName];
                  console.log(`Обрабатываем материал: ${materialName}`);
                  console.log('Исходный цвет:', material.color);
                  console.log('Исходная зеркальность:', material.specular);
                  
                  enhanceMaterialColors(material, materialName);
                  
                  console.log('Обработанный цвет:', material.color);
                  console.log('Обработанная зеркальность:', material.specular);
                }
              }
            }
          }

          // Дожидаемся загрузки всех текстур
          console.log('Ждем загрузки всех текстур');
          await Promise.all(texturePromises);
    
          // Загружаем OBJ
          const objText = await readFileAsText(objFile);
          const objLoader = new THREE.OBJLoader();
          if (materials) {
            console.log('Устанавливаем текстуры');
            objLoader.setMaterials(materials);
          }
          
          await refreshUI('Конвертация ...');
          
          console.log('Парсим OBJ');
          const model = objLoader.parse(objText);

          // Обновляем прогресс после парсинга
          await refreshUI('Конвертация ...');
          
          // После загрузки модели отключаем прозрачность для материалов Fasad1/2/3
          model.traverse((child) => {
            if (child.isMesh && child.material) {
              const materialsArray = Array.isArray(child.material) ? child.material : [child.material];
              materialsArray.forEach((mat) => {
                const matName = (mat && mat.name) ? mat.name : '';
                if (matName.includes('Fasad1') || matName.includes('Fasad2') || matName.includes('Fasad3') || mat.userData.fasade == 1) {
                  mat.transparent = true; //false;
                  mat.opacity = 1.0;
                  mat.needsUpdate = true;
                }
              });
            }
          });

          /*
          // Проверяем материалы после загрузки OBJ
            model.traverse((child) => {
            if (child.isMesh && child.material) {
              console.log('Проверка материала:', child.material.name);
              console.log('Цвет:', child.material.color);
              console.log('Зеркальность:', child.material.specular);
              console.log('Текстура:', child.material.map ? 'есть' : 'нет');
              console.log('Прозрачность:', child.material.opacity);
            }
          });
          */

          console.log('Запускаем оптимизацию модели');
          // Оптимизация модели
          optimizeModel(model);
          
          await refreshUI('Конвертация ...');

          //закидываем в просмотр (материалы на время показа упрощаются)
          loadModel(model);

          await refreshUI('Конвертация ...');

          /* Перед экспортом возвращаем исходные материалы и видимость:
             «плоское» превью не должно попасть в GLB. После экспорта
             снова уплощаем и скрываем присадку. */
          restorePreviewMaterials(model);
          restorePreviewExtras(model);
          
          // Экспорт в GLB
          const exporter = new THREE.GLTFExporter();
          console.log('Экспорт GLB');
          /* ВАЖНО: подпись GLTFExporter.parse — (input, onDone, onError, options).
             Раньше объект настроек стоял третьим аргументом, поэтому binary не
             применялся: экспортировался JSON, а в колбэк приходил ОБЪЕКТ.
             Дальше new Blob([объект]) превращал его в строку, и в файл уходил
             текст «[object Object]». */
          exporter.parse(model, (glb) => {
            flattenPreviewMaterials(model);
            hidePreviewExtras(model);

            // Очищаем URL объекты текстур
            textureMap.forEach(texture => {
              if (texture instanceof THREE.Texture) {
                texture.dispose();
              }
            });

            refreshUI('Конвертация ...');

            resolve(glb);
          }, (err) => {
            reject(err || new Error('экспорт GLB не удался'));
          }, {
            binary: true,
            trs: false,
            onlyVisible: true,
            truncateDrawRange: true,
            maxTextureSize: 800,
            embedImages: true,
            includeCustomExtensions: true
          });
          
        } catch (error) {
          reject(error);
        }
      });
    }

/* Проверка, что на выходе действительно GLB: первые 4 байта — «glTF».
   Иначе в файл может уехать что угодно (например, строка «[object Object]»). */
function ensureGlbBuffer(data) {
  let buf = data;
  if (buf instanceof Blob) { throw new Error('ожидался ArrayBuffer, пришёл Blob'); }
  if (!(buf instanceof ArrayBuffer) && !ArrayBuffer.isView(buf)) {
    throw new Error('экспорт вернул не бинарные данные, а ' + Object.prototype.toString.call(buf));
  }
  const arr = buf instanceof ArrayBuffer ? new Uint8Array(buf) : new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength);
  const magic = arr.length >= 4 ? (arr[0] | (arr[1] << 8) | (arr[2] << 16) | (arr[3] << 24)) : 0;
  if (magic !== 0x46546C67) {
    throw new Error('на выходе не GLB (нет метки glTF), первых байт: ' + arr.length);
  }
  return buf;
}

    function refreshUI(message) {
      return new Promise(resolve => {
        // Сначала обновляем статус
        updateProgressStatus(message);
        
        // И даем браузеру шанс обновиться
        setTimeout(resolve, 0);
      });
    }

    function readFileAsText(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result);
        reader.onerror = (e) => reject(new Error('Ошибка чтения файла'));
        reader.readAsText(file);
      });
    }

    function getScaleFactor(model) {
      // Вычисляем ограничивающую рамку для всей модели
      const bbox = new THREE.Box3().setFromObject(model);
      const size = new THREE.Vector3();
      bbox.getSize(size);
      
      // Находим максимальное измерение
      const maxDimension = Math.max(size.x, size.y, size.z);
      console.log(size.x, size.y, size.z);
      // Определяем единицы измерения на основе эвристик
      if (maxDimension > 100) {
          return 0.001;
      } else {
        return 1;
      }
  }

    function optimizeModel(model) {
      // Масштабируем модель
      const scaleFactor = getScaleFactor(model);
      isBazizModel = scaleFactor == 0.001 ? true : false;
      model.scale.set(scaleFactor, scaleFactor, scaleFactor);
      
      // Обходим все дочерние объекты
      model.traverse((child) => {
        if (child instanceof THREE.Mesh && child.geometry && child.material) {
          // Оптимизация геометрии
          if (child.geometry) {
            // ПЕРЕВОРОТ UV КООРДИНАТ - добавляем это
            if (child.geometry.attributes.uv && isBazizModel) {
              const uv = child.geometry.attributes.uv;
              for (let i = 0; i < uv.count; i++) {
                uv.setY(i, 1 - uv.getY(i)); // Переворачиваем по вертикали
              }
              uv.needsUpdate = true;
            }            
            // Объединение атрибутов
            if (THREE.BufferGeometryUtils && THREE.BufferGeometryUtils.mergeVertices) {
              child.geometry = THREE.BufferGeometryUtils.mergeVertices(child.geometry);
            }

            // Удаление неиспользуемых атрибутов
            //child.geometry.deleteAttribute('normal');
            //child.geometry.deleteAttribute('uv');

            // Пересчет нормалей если их нет
            if (!child.geometry.attributes.normal) {
              child.geometry.computeVertexNormals();
            }

          }
        }
     
    });
    }

  // Установка курсора ожидания
  function showLoadingCursor() {
    document.body.style.cursor = 'wait';
  }

  // Возврат нормального курсора
  function hideLoadingCursor() {
    document.body.style.cursor = 'default';
  }


//-----------------------------------
// просмотр

    
    function init() {
      scene = new THREE.Scene();
      //scene.background = new THREE.Color(0x666666);
      //scene.background = new THREE.Color(window.getComputedStyle(s3vContainer).backgroundColor);
      //scene.background = new THREE.Color().setRGB( 0.5, 0.5, 0.7, THREE.SRGBColorSpace ),
      camera = new THREE.PerspectiveCamera(60, s3vContainer.clientWidth / s3vContainer.clientHeight, 0.1, 100);
      camera.position.set(0, 1.5, 3);

      renderer = new THREE.WebGLRenderer({ 
        antialias: true,
        alpha: true // Добавляем прозрачность
      });
      //renderer.setClearColor(window.getComputedStyle(s3vContainer).backgroundColor, 1); // Устанавливаем цвет очистки
      renderer.setClearColor(0x000000, 0); // Прозрачный фон
      renderer.setClearAlpha(0); // Для корректного отображения градиента
      renderer.setSize(s3vContainer.clientWidth, s3vContainer.clientHeight);
      // Убедитесь, что для обоих загрузчиков одинаковые настройки
      renderer.toneMapping = THREE.ACESFilmicToneMapping;
      renderer.toneMappingExposure = 0.8;
      /* Мягкие тени включаем только на кадр скриншота: в интерактивном превью
         они удваивают число отрисовок на каждый кадр (модель вращается). */
      renderer.shadowMap.enabled = false;
      renderer.shadowMap.type = THREE.PCFSoftShadowMap;
      s3vContainer.appendChild(renderer.domElement);
      
      // Сразу делаем первый рендер чтобы убрать черную вспышку
      renderer.render(scene, camera);

      // Light
      /* Свет мягкий, но не «пересвеченный»: раньше hemi 1.2 + dir 1 выжигали
         светлые текстуры — превью получалось белёсым и плоским. */
      const hemiLight = new THREE.HemisphereLight(0xffffff, 0x555555, 0.75);
      hemiLight.position.set(0, 12, 0);
      scene.add(hemiLight);
      const dirLight = new THREE.DirectionalLight(0xffffff, 0.6);
      dirLight.position.set(3, 10, 10);
      dirLight.castShadow = true;
      dirLight.shadow.mapSize.set(1024, 1024);
      dirLight.shadow.bias = -0.0008;
      dirLight.shadow.normalBias = 0.02;
      dirLight.shadow.camera.near = 0.05;
      dirLight.shadow.camera.far = 60;
      scene.add(dirLight);
      scene.add(dirLight.target);
      /* второй, слабый источник сзади-слева — чтобы тёмные бока не были чёрными */
      const fillLight = new THREE.DirectionalLight(0xffffff, 0.3);
      fillLight.position.set(-6, 4, -6);
      scene.add(fillLight);

      // OrbitControls
      const script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/three@0.132.2/examples/js/controls/OrbitControls.js';
      script.onload = () => {
        controls = new THREE.OrbitControls(camera, renderer.domElement);
        controls.target.set(0, 0, 0);
        controls.enableDamping = true;
        controls.dampingFactor = 0.08;
        controls.update();
        controls.addEventListener('start', function() {
          isUserInteracting = true;
          if (autoRotateTimeout) {
            clearTimeout(autoRotateTimeout);
            autoRotateTimeout = null;
          }
        });
        controls.addEventListener('end', function() {
          if (autoRotateTimeout) {
            clearTimeout(autoRotateTimeout);
          }
          autoRotateTimeout = setTimeout(function() {
            isUserInteracting = false;
          }, 5000); // 5 секунд задержки
        });
        // Сразу после инициализации блокируем автовращение и запускаем таймер
        isUserInteracting = true;
        setTimeout(function() {
          isUserInteracting = false;
        }, 9000); // 5 секунд задержки после загрузки
        animate();
      };
      document.body.appendChild(script);
    }

    /* ------------------------------------------------------------------
       Превью модели в окне загрузки: только текстуры, без освещения,
       металла, прозрачности и тональной компрессии.

       Зачем: у моделей Базиса материалы PBR (металл, стекло, «полупрозрачные»
       фасады), а окружения (envMap) в превью нет — металл рендерится чёрным,
       прозрачные детали просвечивают. Получалось тёмное превью с «дырами».
       MeshBasicMaterial показывает ровно цвет/текстуру: быстро и предсказуемо.
       Прозрачность (стекло, линзы) сохраняется, а присадка и крепёж скрываются.

       Исходные материалы и видимость запоминаются и возвращаются перед
       экспортом GLB — в модель они не попадают. */
    const __PREVIEW_FLAT = true;

    function __flatMaterial(mat) {
      if (!mat) return mat;
      const hasMap = !!mat.map;
      const color = hasMap ? new THREE.Color(0xffffff)
                           : (mat.color ? mat.color.clone() : new THREE.Color(0xffffff));

      /* Прозрачность сохраняем: у МДФ-стекла и линз прозрачность задаётся
         transmission, а у обычных материалов — opacity/transparent. */
      const transmission = mat.transmission || 0;
      let opacity = mat.opacity === undefined ? 1 : mat.opacity;
      if (transmission > 0) {
        opacity = Math.min(opacity, Math.max(0.15, 1 - transmission * 0.9));
      }
      const transparent = transmission > 0 || !!mat.transparent || opacity < 0.999;

      /* «металл» без окружения иначе выглядит чёрным — осветляем (только
         непрозрачные: у стекла цвет должен остаться своим) */
      if (!transparent) {
        if (!hasMap && mat.metalness !== undefined && mat.metalness > 0.5) {
          color.lerp(new THREE.Color(0xffffff), 0.6);
        }
        if (color.r < 0.25 && color.g < 0.25 && color.b < 0.25) {
          color.lerp(new THREE.Color(0xffffff), 0.35);
        }
      }

      /* Не MeshBasic, а Lambert: он дешёвый, но даёт мягкий светотеневой
         объём — иначе превью «плоское» и на светлом фоне модель не читается.
         Металла/окружения у Lambert нет, поэтому чёрных деталей не будет. */
      const matColor = color.clone();
      return new THREE.MeshLambertMaterial({
        map: mat.map || null,
        color,
        /* маленькая подсветка, чтобы тёмные бока не проваливались в чёрный */
        emissive: matColor.multiplyScalar(transparent ? 0.04 : 0.06),
        side: THREE.DoubleSide,
        transparent,
        opacity: transparent ? opacity : 1,
        depthWrite: !transparent,
        depthTest: true,
        /* toneMapped по умолчанию (ACES): иначе белые текстуры выжигаются
           в чистый белый — на светлом фоне модель пропадает */
        alphaMap: mat.alphaMap || null,
        alphaTest: transparent ? 0 : (mat.alphaTest || 0),
        vertexColors: !!mat.vertexColors
      });
    }

    /* Присадка и крепёж в превью не нужны: это мелкие отверстия и шурупы,
       которые в каталоге только мешают. В просмотрщике они тоже выключены. */
    function hidePreviewExtras(root) {
      if (!root) return;
      root.traverse((child) => {
        const u = child.userData || {};
        if (u.hw === true || u.role === 'hole' || u.hole === true) {
          if (child.userData.__previewVisible === undefined) {
            child.userData.__previewVisible = child.visible;
          }
          child.visible = false;
        }
      });
    }

    function restorePreviewExtras(root) {
      if (!root) return;
      root.traverse((child) => {
        if (child.userData && child.userData.__previewVisible !== undefined) {
          child.visible = child.userData.__previewVisible;
          delete child.userData.__previewVisible;
        }
      });
    }

    function flattenPreviewMaterials(root) {
      if (!__PREVIEW_FLAT || !root || root.userData.__previewFlat) return;
      const cache = new Map();
      root.traverse((child) => {
        if (!child.isMesh || !child.material) return;
        const convert = (mat) => {
          if (!mat) return mat;
          if (cache.has(mat.uuid)) return cache.get(mat.uuid);
          const flat = __flatMaterial(mat);
          cache.set(mat.uuid, flat);
          return flat;
        };
        if (Array.isArray(child.material)) {
          child.userData.__previewOrigMat = child.material.slice();
          child.material = child.material.map(convert);
        } else {
          child.userData.__previewOrigMat = child.material;
          child.material = convert(child.material);
        }
        /* флаги теней ставим всегда: сам shadow map включается только на
           кадр скриншота (см. alignCameraAndTakeScreenshot) */
        child.castShadow = true;
        child.receiveShadow = true;
      });
      root.userData.__previewFlat = true;
    }

    function restorePreviewMaterials(root) {
      if (!root) return;
      root.traverse((child) => {
        if (child.userData && child.userData.__previewOrigMat) {
          child.material = child.userData.__previewOrigMat;
          delete child.userData.__previewOrigMat;
        }
      });
      delete root.userData.__previewFlat;
    }

    /* Габарит без служебных объектов превью (тень под моделью) */
    function previewBoxOf(root) {
      const box = new THREE.Box3();
      if (!root) return box;
      root.updateMatrixWorld(true);
      const tmp = new THREE.Box3();
      root.traverse((o) => {
        if (!o.isMesh || !o.geometry) return;
        if (o.userData && o.userData.__previewOnly) return;
        tmp.setFromObject(o);
        if (!tmp.isEmpty()) box.union(tmp);
      });
      return box;
    }

    /* Мягкая тень под моделью: на светлом фоне без неё непонятно, где стоит
       изделие. Живёт в сцене, но не в модели — в GLB не попадает. */
    let previewShadow = null;
    function makePreviewShadow(root) {
      if (previewShadow) {
        if (previewShadow.parent) previewShadow.parent.remove(previewShadow);
        if (previewShadow.geometry) previewShadow.geometry.dispose();
        if (previewShadow.material) {
          if (previewShadow.material.map) previewShadow.material.map.dispose();
          previewShadow.material.dispose();
        }
        previewShadow = null;
      }
      const box = previewBoxOf(root);
      if (!box.isEmpty()) {
        const size = box.getSize(new THREE.Vector3());
        const side = Math.max(size.x, size.z) || 1;
        const cvs = document.createElement('canvas');
        cvs.width = cvs.height = 128;
        const g = cvs.getContext('2d');
        const grad = g.createRadialGradient(64, 64, 6, 64, 64, 62);
        grad.addColorStop(0, 'rgba(0,0,0,0.34)');
        grad.addColorStop(0.55, 'rgba(0,0,0,0.16)');
        grad.addColorStop(1, 'rgba(0,0,0,0)');
        g.fillStyle = grad;
        g.fillRect(0, 0, 128, 128);
        const tex = new THREE.CanvasTexture(cvs);
        tex.needsUpdate = true;
        const geo = new THREE.PlaneGeometry(side * 1.5, side * 1.5);
        const mesh = new THREE.Mesh(geo, new THREE.MeshBasicMaterial({
          map: tex, transparent: true, opacity: 0.55, depthWrite: false, toneMapped: false
        }));
        mesh.rotation.x = -Math.PI / 2;
        mesh.position.set((box.min.x + box.max.x) / 2, box.min.y - 0.003, (box.min.z + box.max.z) / 2);
        mesh.userData.__previewOnly = true;
        mesh.renderOrder = -1;
        scene.add(mesh);
        previewShadow = mesh;
      }
    }

    /* Подгоняем карту теней под размер модели: иначе на 3-метровом шкафу
       тень получается «мыльной», а на маленькой тумбе — слишком крупной. */
    function fitPreviewShadow(root) {
      const box = previewBoxOf(root);
      if (box.isEmpty()) return;
      const size = box.getSize(new THREE.Vector3());
      const center = box.getCenter(new THREE.Vector3());
      const r = Math.max(size.x, size.y, size.z) || 1;
      const light = scene.children.find((o) => o.isDirectionalLight && o.castShadow);
      if (!light) return;
      light.target.position.copy(center);
      light.target.updateMatrixWorld();
      light.position.set(center.x + r * 1.1, center.y + r * 1.8, center.z + r * 1.4);
      const cam = light.shadow.camera;
      cam.left = -r * 0.85; cam.right = r * 0.85;
      cam.top = r * 0.85; cam.bottom = -r * 0.85;
      cam.near = 0.05; cam.far = r * 6;
      cam.updateProjectionMatrix();
      if (light.shadow.map) { light.shadow.map.dispose(); light.shadow.map = null; }
    }

    function loadModel(load_model) {
      if (model) {
        scene.remove(model);
        model.traverse(child => {
          if (child.geometry) child.geometry.dispose();
          if (child.material) {
            if (Array.isArray(child.material)) {
              child.material.forEach(mat => mat.dispose());
            } else {
              child.material.dispose();
            }
          }
        });
        model = null;
        if (modelGroup) {
          scene.remove(modelGroup);
          modelGroup = null;
        }
      }
      model = load_model;
      // Центрируем модель
      const box = previewBoxOf(model);
      const center = box.getCenter(new THREE.Vector3());
      model.position.sub(center); // смещаем модель так, чтобы её центр был в (0,0,0)
      // Добавляем модель в группу и группу в сцену
      modelGroup = new THREE.Group();
      modelGroup.add(model);
      scene.add(modelGroup);

      /* превью — «плоские» материалы (см. flattenPreviewMaterials) */
      try { flattenPreviewMaterials(model); } catch (eFlat) { console.warn('[preview] упрощение материалов:', eFlat.message); }
      /* присадка и крепёж в превью не показываем */
      try { hidePreviewExtras(model); } catch (eHw) { console.warn('[preview] скрытие присадки:', eHw.message); }
      /* мягкая тень под изделием */
      try { makePreviewShadow(model); } catch (eSh) { console.warn('[preview] тень:', eSh.message); }
      /* карта теней под размер модели */
      try { fitPreviewShadow(model); } catch (eFs) { console.warn('[preview] тени:', eFs.message); }

      fitCameraToObject(camera, model, controls);
    }

    function fitCameraToObject(camera, object, controls) {
      const box = previewBoxOf(object);
      const size = box.getSize(new THREE.Vector3());
      const center = box.getCenter(new THREE.Vector3());
      const maxDim = Math.max(size.x, size.y, size.z);
      const fov = camera.fov * (Math.PI / 180);
      let cameraZ = Math.abs(maxDim / 2 / Math.tan(fov / 2));
      cameraZ *= 1.5;
      camera.position.set(center.x, center.y + maxDim * 0.2, center.z + cameraZ);
      camera.lookAt(center);
      if (controls) {
        controls.target.copy(center);
        controls.update();
      }
    }

    function animate() {
      animationFrameId = requestAnimationFrame(animate); // Сохраняем ID
      if (modelGroup && !isUserInteracting) {
        modelGroup.rotation.y += 0.0005;
      }
      if (controls) controls.update();
      renderer.render(scene, camera);
    }
    
    window.addEventListener('resize', resizeRenderContainer);
    
    function resizeRenderContainer(){
      if (camera) {
        camera.aspect = s3vContainer.clientWidth / s3vContainer.clientHeight;
        camera.updateProjectionMatrix();
        renderer.setSize(s3vContainer.clientWidth, s3vContainer.clientHeight);
      }
    } 

    function showS3V() {
      while (s3vContainer.firstChild) {
        s3vContainer.removeChild(s3vContainer.firstChild);
      }
      if (!renderer) init();
    }

    function cleanupScene() {
      // 1. Проверяем существование объектов перед очисткой
      if (!scene || !renderer) return;

      // 1. Остановка анимации (если используется requestAnimationFrame)
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
        animationFrameId = null;
      }
    
      // 2. Удаление всех объектов из сцены
      while(scene.children.length > 0) {
        const object = scene.children[0];
        
        // Особое внимание для мешей с геометрией и материалами
        if (object.isMesh) {
          if (object.geometry) {
            object.geometry.dispose();
          }
          if (object.material) {
            // Для массивов материалов
            if (Array.isArray(object.material)) {
              object.material.forEach(material => material.dispose());
            } else {
              object.material.dispose();
            }
          }
        }
        
        scene.remove(object);
      }
    
      // 3. Очистка других ресурсов
      if (renderer) {
        // Удаление canvas из DOM
        if (renderer.domElement.parentNode === s3vContainer) {
          s3vContainer.removeChild(renderer.domElement);
        }

        renderer.dispose();
        renderer.forceContextLoss();
        renderer.domElement = null;
      }
    
      // 4. Сброс остальных переменных
      scene = null;
      camera = null;
      renderer = null;
    
    }
    
//-----------------------------------
// общепроизводственные  
// Sidebar toggle for mobile
const menuToggle = document.getElementById('menuToggle');
const sidebar = document.getElementById('sidebar');

if (menuToggle) {
  menuToggle.addEventListener('click', function() {
    sidebar.classList.toggle('open');
    if (window.innerWidth <= 992) {
      sidebar.style.background = "#fff";
    }
  });
}

// Close sidebar when clicking on a link (for mobile)
const navLinks = document.querySelectorAll('aside a');
navLinks.forEach(link => {
    link.addEventListener('click', function() {
        if (window.innerWidth <= 992) {
            sidebar.classList.remove('open');
        }
    });
});

whenReady(function() {
  //console.log('DOM 1: Загружен!');
  const menuLinks = document.querySelectorAll('aside nav ul li a');
    const sections = Array.from(menuLinks)
        .map(link => document.querySelector(link.getAttribute('href')))
        .filter(Boolean);

    function setActive(link) {
        menuLinks.forEach(a => a.parentElement.classList.remove('active'));
        if (link) link.parentElement.classList.add('active');
    }

    // Подсветка при клике
    menuLinks.forEach(link => {
        link.addEventListener('click', function() {
            setActive(link);
        });
    });
 
    // Подсветка при прокрутке
    window.addEventListener('scroll', function() {
        let currentSection = null;
        const scrollPos = window.scrollY + 100;
        sections.forEach((section, i) => {
            if (section.offsetTop <= scrollPos) {
                currentSection = menuLinks[i];
            }
        });
        setActive(currentSection);
        //сайдбар делаем непрозрачным 
        if (sidebar && 'style' in sidebar) {
          if (window.scrollY > 1000 || window.innerWidth <= 992) {
              sidebar.style.background = "var(--pico-background-color)";
          } else {
              sidebar.style.background = "transparent";
          }
        }
        //меняем цвет лого квадрата
        updateBackgroundColor();
        updateParallax();
      });

    // Подсветить первый пункт при загрузке
    setActive(menuLinks[0]);
    updateBackgroundColor();

    if (uploadBtn) uploadBtn.addEventListener('click',goToService);
});

function copyToClipboardOld(button, sid) {
    const copyInput = document.getElementById(sid);
    copyInput.select();
    
    try {
      document.execCommand('copy');
      
      // Меняем иконку на короткое время
      const icon = button.querySelector('.fa');
      icon.classList.remove('fa-copy');
      icon.classList.add('fa-check');
      
      setTimeout(() => {
        icon.classList.remove('fa-check');
        icon.classList.add('fa-copy');
      }, 2000);
      
    } catch (err) {
      console.error('Ошибка копирования:', err);
      alert('Не удалось скопировать текст');
    }
}

//загрузка на сервер
async function goToService() {
    const s_user = getUser();
    const s_name = document.getElementById('modelName').value;
    const s_desk = document.getElementById('modelDescription').value;

    // Проверка наличия glbBlob
    if (!glbBlob) {
        //showAlert('Сначала сконвертируйте модель!', 'warning');
        showStatus('Сначала сконвертируйте модель!');
        return;
    }

    // Выравниваем камеру и делаем скриншот
    const screenshotBlob = await alignCameraAndTakeScreenshot();

    // Формируем данные для отправки
    const formData = new FormData();
    formData.append('model', glbBlob, s_name.endsWith('.glb') ? s_name : (s_name + '.glb'));
    formData.append('user', s_user);
    formData.append('name', s_name);
    formData.append('description', s_desk);
    
    if (screenshotBlob) {
        formData.append('screenshot', screenshotBlob, 'preview.png');
    }

    // Отключаем кнопку, если есть
    if (uploadBtn) uploadBtn.disabled = true;
    showLoadingCursor();
    spinner.classList.remove('hidden-field');
    statusEl.classList.remove('hidden-field')
    statusEl.textContent = 'Загрузка модели...'
    const progressInterval = fackeProgessStatus('Загрузка модели...')

    fetch('/upload_model', {
        method: 'POST',
        body: formData
    })
    .then(async response => {
        if (!response.ok) {
            throw new Error('Ошибка загрузки: ' + response.statusText);
        }
        hideLoadingCursor();
        return response.text();
    })
    .then(link => {
        
        // Помещаем полученную строку в resultLink
        const fullUrl = window.location.origin + link;
        linkDialog.setAttribute('open','');
        resultLink.value = fullUrl;
        resultOpen.href = fullUrl;
        clearInterval(progressInterval);
        spinner.classList.add('hidden-field');
        statusEl.classList.add('hidden-field');
        loadDialog.removeAttribute('open','');
        hideLoadingCursor();
        //присобачим кнопке закрытия обновление страницы
        document.getElementById('close_final_dlg').onclick=function(){
          document.getElementById('link-dialog').removeAttribute('open', '');
          window.location.reload();
        }
    })
    .catch(err => {
        hideLoadingCursor();
        //showAlert('Ошибка загрузки: ' + err.message, 'danger');
        showStatus('Ошибка загрузки: ' + err.message);
    })
    .finally(() => {
      hideLoadingCursor();  
      if (uploadBtn) uploadBtn.disabled = false;
    });

}

function getUser() {
  // Находим input по id
  const userInput = document.getElementById('userEmail');
  
  // Если input существует и имеет значение - возвращаем его
  if (userInput && userInput.value && userInput.value.trim() !== '') {
    return userInput.value.trim();
  }
  
  // Если пользователь не авторизован, возвращаем "guest"
  return "guest";
}

// Функция для выравнивания камеры и создания скриншота
async function alignCameraAndTakeScreenshot() {
  return new Promise((resolve, reject) => {
      try {
          // Выравниваем камеру для лучшего обзора модели
          alignCameraToModel();

          // Даем время на рендер после изменения камеры
          setTimeout(() => {
              try {
                  // Рендерим сцену с выровненной камерой.
                  // Мягкие тени включаем только на этот кадр: в интерактивном
                  // превью они не нужны и замедляют вращение модели.
                  const shadowWas = renderer.shadowMap ? renderer.shadowMap.enabled : false;
                  if (renderer.shadowMap) renderer.shadowMap.enabled = true;
                  renderer.render(scene, camera);

                  // Создаем скриншот
                  const canvas = renderer.domElement;
                  const croppedBlob = cropCanvasCenter(canvas, 464, 296);
                  if (renderer.shadowMap) renderer.shadowMap.enabled = shadowWas;
                  if (croppedBlob) {
                    resolve(croppedBlob);
                  } else {
                    throw new Error('Не удалось создать обрезанный скриншот');
                  }
              } catch (error) {
                  reject(error);
              }
          }, 100);
          
      } catch (error) {
          reject(error);
      }
  });
}

// Функция для обрезки canvas по центру
function cropCanvasCenter(sourceCanvas, targetWidth, targetHeight) {
  try {
      // Создаем временный canvas для обрезанного изображения
      const tempCanvas = document.createElement('canvas');
      tempCanvas.width = targetWidth;
      tempCanvas.height = targetHeight;
      const tempCtx = tempCanvas.getContext('2d');

      /* Фон — мягкий вертикальный градиент с более тёмным низом: на чистом
         белом светлая мебель (дуб, белый ЛДСП) сливается с фоном. */
      const bg = tempCtx.createLinearGradient(0, 0, 0, targetHeight);
      bg.addColorStop(0, '#f2f1ee');
      bg.addColorStop(0.55, '#e6e4df');
      bg.addColorStop(1, '#c9c5bd');
      tempCtx.fillStyle = bg;
      tempCtx.fillRect(0, 0, targetWidth, targetHeight);

      // Вычисляем координаты для обрезки по центру
      const sourceWidth = sourceCanvas.width;
      const sourceHeight = sourceCanvas.height;
      
      // Проверяем, что целевой размер не больше исходного
      if (targetWidth > sourceWidth || targetHeight > sourceHeight) {
          console.warn('Target size larger than source, scaling instead of cropping');
          // Если целевой размер больше, просто масштабируем
          tempCtx.drawImage(sourceCanvas, 0, 0, targetWidth, targetHeight);
      } else {
          // Обрезаем центральную часть
          const sourceX = (sourceWidth - targetWidth) / 2;
          const sourceY = (sourceHeight - targetHeight) / 2;

          // Рисуем центральную часть
          tempCtx.drawImage(
              sourceCanvas,
              sourceX, sourceY, targetWidth, targetHeight, // source rect (какую область берем)
              0, 0, targetWidth, targetHeight              // destination rect (куда рисуем)
          );
      }

      // Конвертируем в blob
      return new Promise(resolve => {
          tempCanvas.toBlob(resolve, 'image/png', 0.9);
      });

  } catch (error) {
      console.error('Error cropping canvas:', error);
      return null;
  }
}

// Функция для автоматического выравнивания камеры под модель
function alignCameraToModel() {
  if (!scene || scene.children.length === 0) {
      console.warn('Сцена пуста, невозможно выровнять камеру');
      return;
  }

  // Создаем bounding box для всей сцены (без служебной тени под моделью)
  const bbox = previewBoxOf(scene);
  const center = bbox.getCenter(new THREE.Vector3());
  const size = bbox.getSize(new THREE.Vector3());
  
  // Вычисляем оптимальное расстояние для камеры
  const maxDim = Math.max(size.x, size.y, size.z);
  const fov = camera.fov * (Math.PI / 180);
  
  // Вычисляем расстояние так, чтобы модель полностью помещалась в кадр
  let cameraDistance = maxDim / (2 * Math.tan(fov / 2));
  
  // Добавляем небольшой зазор
  cameraDistance *= 1.25;

  // Позиционируем камеру
  camera.position.set(
      center.x + size.x * 0.35,
      center.y + size.y * 0.35, // Немного выше центра для лучшего обзора
      center.z + cameraDistance
  );
  
  // Направляем камеру на центр модели
  camera.lookAt(center);
  
  // Обновляем матрицу проекции
  camera.updateProjectionMatrix();
  
  console.log('Camera aligned to model:', {
      center: center,
      size: size,
      cameraPosition: camera.position,
      cameraDistance: cameraDistance
  });
}

// Анимация счетчиков при появлении блока на экране
function animateCounter(element, target, duration = 1200) {
  const start = 0;
  const startTime = performance.now();
  const end = Number(target);

  function update(currentTime) {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);
    const value = Math.floor(progress * (end - start) + start);
    element.textContent = value;
    if (progress < 1) {
      requestAnimationFrame(update);
    } else {
      element.textContent = end;
    }
  }
  requestAnimationFrame(update);
}

//запрос счетчиков с сервера
function updateAndAnimateCounters() {
  fetch('/analytics/getcounters')
    .then(response => response.json())
    .then(data => {
      const counters = [
        { id: 'counter-models', value: data.models },
        { id: 'counter-users', value: data.users },
        { id: 'counter-views', value: data.views }
      ];
      counters.forEach(({ id, value }) => {
        const el = document.getElementById(id);
        if (el) {
          el.setAttribute('data-target', value);
          animateCounter(el, value);
        }
      });
    });
}
//ловим появление счетчиков на экране чтобы запустить анимацию счетчиков 
whenReady(function() {
  const countersBlock = document.querySelector('.counters');
  if (!countersBlock) return;

  let animated = false;
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting && !animated) {
        updateAndAnimateCounters();
        animated = true;
      }
    });
  }, { threshold: 0.3 });

  observer.observe(countersBlock);
});


function fackeProgessStatus(message) {
  statusEl.data = 0;
  const progressInterval = setInterval(async () => {
    updateProgressStatus(message);
    
    if (statusEl.data >= 90) clearInterval(progressInterval);
  }, 300);
  return progressInterval;
}

function updateProgressStatus(message) {
    statusEl.data = (+statusEl.data || 0) + 5; // Унарный + для преобразования

    statusEl.textContent = `${message} ${statusEl.data}%`;
}

function showStatus(message) {
  statusEl.classList.remove('hidden-field');
  statusEl.textContent = message;
         setTimeout(() => {
          statusEl.classList.add('hidden-field');
        }, 3000); 
}
// меняем цвет квадрата при прокрутке
const logoSquare = document.getElementById('logo-square');
const startColor = '#01b4cd'; // Начальный цвет
const endColor = '#5c6370';   // Конечный цвет

function hexToRgb(hex) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
}

function interpolateColor(color1, color2, factor) {
    const r1 = hexToRgb(color1);
    const r2 = hexToRgb(color2);
    
    const r = Math.round(r1.r + (r2.r - r1.r) * factor);
    const g = Math.round(r1.g + (r2.g - r1.g) * factor);
    const b = Math.round(r1.b + (r2.b - r1.b) * factor);
    
    return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
}

function updateBackgroundColor() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
    const scrollPercentage = scrollTop / scrollHeight;
    
    if (logoSquare){
      // Ограничиваем процент от 0 до 1
      const clampedPercentage = Math.min(Math.max(scrollPercentage, 0), 1);
      
      const newColor = interpolateColor(startColor, endColor, clampedPercentage);
      logoSquare.style.backgroundColor = newColor;
    }
}

function updateParallax() {
  const scrollY = window.pageYOffset;
  const style = document.createElement('style');
  
  if (scrollY < 1000) {
      // Параллакс эффект
      style.innerHTML = `
          body::before {
              transform: translateY(${scrollY * 2}px);
              opacity: 1;
              visibility: visible;
          }
      `;
  } else {
      // Скрываем элемент
      style.innerHTML = `
          body::before {
              opacity: 0;
              visibility: hidden;
              transition: opacity 0.5s ease, visibility 0.5s ease;
          }
      `;
  }
  
  const oldStyle = document.getElementById('bg-style');
  if (oldStyle) oldStyle.remove();
  
  style.id = 'bg-style';
  document.head.appendChild(style);
}

if (typeof window !== 'undefined') {
  window.copyToClipboardOld = copyToClipboardOld;
}

// Получаем элементы
const modal = document.getElementById("videoModal");
const btn = document.querySelector(".youtube-btn"); // Выберите ваш класс кнопки
const closeBtn = document.querySelector(".close");

// Открываем модальное окно при клике на кнопку
if (btn) {
  btn.onclick = function() {
    modal.style.display = "block";
  }
}

// Закрываем модальное окно при клике на крестик
if (closeBtn) {
  closeBtn.onclick = function() {
    modal.style.display = "none";
  }
}

// Закрываем модальное окно при клике вне его
window.onclick = function(event) {
  if (event.target == modal) {
    modal.style.display = "none";
  }
}

// управлем свертыванием равертыванием вьювера
whenReady(function() {
  const expandBtn = document.getElementById('expand-btn');
  const modelCanvas = document.getElementById('container');
  const formFields = document.getElementById('form-fields');
  const dialogArticle = document.querySelector('.load-dialog article');
  
  let isExpanded = false;
  
  if (expandBtn) {
    expandBtn.addEventListener('click', function() {
        isExpanded = !isExpanded;
        
        if (isExpanded) {
            // Развернуть режим
            modelCanvas.classList.add('expanded');
            formFields.classList.add('hidden');
            expandBtn.innerHTML = '⛷'; // Иконка "свернуть"
            expandBtn.title = 'Свернуть';
        } else {
            // Обычный режим
            modelCanvas.classList.remove('expanded');
            formFields.classList.remove('hidden');
            expandBtn.innerHTML = '⛶'; // Иконка "развернуть"
            expandBtn.title = 'Развернуть';
        }
        resizeRenderContainer();
    });
  }
  // Закрытие развернутого режима при закрытии диалога
  const closeBtn = document.querySelector('.load-dialog header button[aria-label="Close"]');
  if (closeBtn) {
    closeBtn.addEventListener('click', function() {
        if (isExpanded) {
            modelCanvas.classList.remove('expanded');
            formFields.classList.remove('hidden');
            isExpanded = false;
            expandBtn.innerHTML = '⛶';
            expandBtn.title = 'Развернуть';
        }
    });
  }
});

class ScrollToTop {
  constructor() {
    this.button = document.getElementById('scrollToTop');
    this.init();
  }
  
  init() {
    // Создаем кнопку если её нет
    if (!this.button) {
      this.createButton();
    }
    
    this.addEventListeners();
  }
  
  createButton() {
    this.button = document.createElement('button');
    this.button.id = 'scrollToTop';
    this.button.className = 'scroll-to-top';
    this.button.innerHTML = '↑';
    this.button.setAttribute('aria-label', 'Наверх');
    document.body.appendChild(this.button);
  }
  
  addEventListeners() {
    window.addEventListener('scroll', () => this.toggleVisibility());
    this.button.addEventListener('click', () => this.scrollToTop());
  }
  
  toggleVisibility() {
    const scrolled = window.pageYOffset;
    if (scrolled > 600) {
      this.button.classList.add('visible');
    } else {
      this.button.classList.remove('visible');
    }
  }
  
  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
}

// Инициализация
new ScrollToTop();

// Функции MTL редактора
whenReady(function() {
  const editor = document.getElementById('editor');
  const lineNumbers = document.getElementById('lineNumbers');
  const lineCount = document.getElementById('lineCount');
  const charCount = document.getElementById('charCount');
  const mtlSave = document.getElementById('mtl-save');
  const searchInput = document.getElementById('searchInput');
  const searchNext = document.getElementById('searchNext');
  const searchCounter = document.getElementById('searchCounter');
  
  let searchMatches = [];
  let currentMatchIndex = -1;
            
  // Обновление нумерации строк
  function updateLineNumbers(count) {
      lineNumbers.innerHTML = '';
      lineCount.textContent = `Строк: ${count}`;
      
      for (let i = 1; i <= count; i++) {
          const lineNumber = document.createElement('div');
          lineNumber.textContent = i;
          lineNumbers.appendChild(lineNumber);
      }
  }
  
  function highlightMTL(text) { 
      // Разбиваем текст на строки
      const lines = text.split('\n');                                               
      // Обновляем счетчик строк и символов
      updateLineNumbers(lines.length);
      charCount.textContent = `Символов: ${text.length}`;
  }

    // Инициализация подсветки при загрузке
    highlightMTL(editor.value);

    // Функция поиска текста
    function performSearch() {
      const searchText = searchInput.value.trim();
      if (!searchText) {
          searchCounter.textContent = 'Найдено: 0';
          return;
      }
      
      const text = editor.value;
      const flags = 'gi';
      const regex = new RegExp(escapeRegExp(searchText), flags);
      
      searchMatches = [];
      let match;
      
      while ((match = regex.exec(text)) !== null) {
          searchMatches.push({
              start: match.index,
              end: match.index + match[0].length,
              text: match[0]
          });
      }
      
      updateSearchCounter();
      currentMatchIndex = -1;
    }
    
    // Экранирование специальных символов для RegExp
    function escapeRegExp(string) {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }
    
    // Обновление счетчика найденных совпадений
    function updateSearchCounter() {
        const count = searchMatches.length;
        searchCounter.textContent = `Найдено: ${count}`;
        if (count > 0 && currentMatchIndex >= 0) {
            searchCounter.textContent += ` (${currentMatchIndex + 1}/${count})`;
        }
    }
    
    // Прокрутка к указанному совпадению
    function scrollToMatch(index) {
        if (index < 0 || index >= searchMatches.length) return;
        
        const match = searchMatches[index];
        const text = editor.value;
        const lines = text.substring(0, match.start).split('\n');
        const lineNumber = lines.length;
        const lineHeight = parseInt(getComputedStyle(editor).lineHeight);
        
        // Выделяем найденный текст
        editor.focus();
        editor.setSelectionRange(match.start, match.end);
        // Прокручиваем редактор к нужной строке
        editor.scrollTop = (lineNumber - 1) * lineHeight;
                
        updateSearchCounter();
    }
    
    // Переход к следующему совпадению
    function goToNextMatch() {
        if (searchMatches.length === 0) return;
        currentMatchIndex = (currentMatchIndex + 1) % searchMatches.length;
        scrollToMatch(currentMatchIndex);
    }

      // Обработчики событий
    editor.addEventListener('input', function() {
        highlightMTL(editor.value);
        performSearch(); // Перезапускаем поиск при изменении текста
    });
          

    // Автоматическое обновление нумерации строк при прокрутке
    editor.addEventListener('scroll', function() {
        lineNumbers.scrollTop = editor.scrollTop;
    });

    searchInput.addEventListener('input', performSearch);
    searchInput.addEventListener('keypress', function(e) {
        if (e.key === 'Enter') {
            goToNextMatch();
        }
    });
    
    searchNext.addEventListener('click', goToNextMatch);

    mtlSave.addEventListener('click', async function() {
      const result = await showConfirm("Вы действительно хотите применить изменения?");
      if (result) {
        mtlDialog.removeAttribute('open');
        mtlText = editor.value;  
        getMtlFromEdit = true;
        updateUI();
      }  
    });

    mtleditBtn.addEventListener ('click', function() {
      if (mtlFile) {
        mtlDialog.setAttribute('open','');
        editor.value = mtlText;
        highlightMTL(editor.value);
      } else {
        showAlert('Так вы не загрузили MTL файл.');
      }
    });
});

/* --- экспорт в window для inline-обработчиков --- */
/* webpack оборачивает файл в функцию, поэтому объявления верхнего уровня
   не становятся глобальными, и onclick="имя()" в шаблонах падал с
   «is not defined». Экспортируем явно. */
try { window.alignCameraToModel = alignCameraToModel; } catch (e) {}
try { window.animateCounter = animateCounter; } catch (e) {}
try { window.cropCanvasCenter = cropCanvasCenter; } catch (e) {}
try { window.ensureGlbBuffer = ensureGlbBuffer; } catch (e) {}
try { window.fackeProgessStatus = fackeProgessStatus; } catch (e) {}
try { window.getUser = getUser; } catch (e) {}
try { window.handleAddFiles = handleAddFiles; } catch (e) {}
try { window.handleFiles = handleFiles; } catch (e) {}
try { window.hexToRgb = hexToRgb; } catch (e) {}
try { window.interpolateColor = interpolateColor; } catch (e) {}
try { window.showStatus = showStatus; } catch (e) {}
try { window.updateAndAnimateCounters = updateAndAnimateCounters; } catch (e) {}
try { window.updateBackgroundColor = updateBackgroundColor; } catch (e) {}
try { window.updateParallax = updateParallax; } catch (e) {}
try { window.updateProgressStatus = updateProgressStatus; } catch (e) {}
try { window.updateUI = updateUI; } catch (e) {}
